<app-header></app-header>

<div class="profile-page mobile-view">
  <header class="profile-header">
    <div class="profile-title">Profile</div>
    <button type="button" class="logout" (click)="onLogout()">
      <img src="/assets/images/Logout.png" alt="Logout" width="20" height="20" />
      <span>Logout</span>
    </button>
  </header>

  <section class="user-block">
    <div class="avatar">{{ initials() }}</div>
    <div class="user-name">{{ name() }}</div>
    <div class="user-email">{{ email() }}</div>
  </section>

  <section class="persona-section">
    <div class="persona-title">Select Persona</div>

    <div class="persona-list">
      <button
        class="persona-item"
        *ngFor="let p of personas()"
        type="button"
        [class.selected]="selectedPersona() === p.id"
        (click)="onSelectPersona(p.id)">
        <div class="persona-icon" [class.selected]="selectedPersona() === p.id">
          <img [src]="selectedPersona() === p.id ? p.iconSelected : p.icon" alt="{{p.label}}" />
        </div>
        <div class="persona-label" [class.selected]="selectedPersona() === p.id">{{ p.label }}</div>
      </button>
    </div>
  </section>

  <app-navbar [items]="[
    { id: 'profile', label: 'Profile', selectedIcon: '/assets/images/Person_Selected.png', unselectedIcon: '/assets/images/Person_Unselected.png' },
    { id: 'home', label: 'Homepage', selectedIcon: '/assets/images/Home_Selected.png', unselectedIcon: '/assets/images/Home_Unselected.png' },
    { id: 'contacts', label: 'Contacts', selectedIcon: '/assets/images/Contact_Selected.png', unselectedIcon: '/assets/images/Contact_Unselected.png' }
  ]" [selectedId]="'profile'" (selectedIdChange)="onNavChange($event)"></app-navbar>
</div>

<!-- Desktop View -->
<div class="profile-desktop-view">
  <div class="profile-desktop-heading">
    <div class="profile-desktop-title">Profile</div>
    <button type="button" class="logout-desktop" (click)="onLogout()">
      <img src="/assets/images/Logout.png" alt="Logout" width="45" height="45" />
      <span>Logout</span>
    </button>
  </div>

  <div class="profile-desktop-card">
    <div class="profile-desktop-user">
      <div class="avatar avatar-desktop">{{ initials() }}</div>
      <div class="profile-desktop-details">
        <div class="desktop-name">{{ name() }}</div>
        <div class="desktop-email">{{ email() }}</div>
      </div>
    </div>

    <div class="desktop-persona-section">
      <div class="desktop-persona-title">Select Persona</div>
      <div class="desktop-persona-grid">
        <button
          class="persona-item-desktop"
          *ngFor="let p of personas()"
          type="button"
          [class.selected]="selectedPersona() === p.id"
          (click)="onSelectPersona(p.id)">
          <div class="persona-icon-desktop" [class.selected]="selectedPersona() === p.id">
            <img [src]="selectedPersona() === p.id ? p.iconSelected : p.icon" alt="{{p.label}}" />
          </div>
          <div class="persona-label-desktop" [class.selected]="selectedPersona() === p.id">{{ p.label }}</div>
        </button>
      </div>
    </div>
  </div>
</div>
